"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SoulModule = require('./SoulModule');
/**
* Set up notification tokens, and send push notification
* @extends SoulModule
*/


var System =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(System, _SoulModule);

  function System() {
    _classCallCheck(this, System);

    return _possibleConstructorReturn(this, _getPrototypeOf(System).apply(this, arguments));
  }

  _createClass(System, [{
    key: "setNotificationTokens",

    /**
    * setNotificationTokens
    * @param {Object} params
    * @param {string} params.notificationTokens.GCM
    * @param {string} params.notificationTokens.APNS
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.system.setNotificationTokens
    */
    value: function setNotificationTokens(_ref, callback) {
      var notificationTokens = _ref.notificationTokens;
      return this.api.patch(function (res) {
        return res.me.notificationTokens;
      }, 'me', {
        notificationTokens: notificationTokens
      }, callback);
    }
    /**
    * getNotificationTokens
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.system.getNotificationTokens
    */

  }, {
    key: "getNotificationTokens",
    value: function getNotificationTokens(callback) {
      return this.api.get(function (res) {
        return res.me.notificationTokens;
      }, 'me', callback);
    }
    /**
    * Public constants defined in your Application dashboard.
    * This variables are defined per-application (not per-user) and can be used
    * to store generic client configuration settings such as feature toggles,
    * release info, public announcements, etc.
    * The constants are read-only via API and can be set only via Application dashboard
    * by Application Administrator.
    * You can create as many namespaces as you want in
    * you Applicaton Dashboard and store any schemaless json data here.
    * @param {Object} params
    * @param {string} params.namespace
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.system.getConstants
    */

  }, {
    key: "getConstants",
    value: function getConstants(_ref2, callback) {
      var namespace = _ref2.namespace;
      return this.api.get("application/constants/".concat(namespace), callback);
    }
    /**
    * Get feature toggles
    * @param {Object} [params] - Query params like anonymous_user
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.system.getFeatures
    */

  }, {
    key: "getFeatures",
    value: function getFeatures() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isAuthorized = arguments.length > 1 ? arguments[1] : undefined;
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var reqParams = isAuthorized ? params : Object.assign({}, params, {
        apiKey: this.apiKey
      });
      return this.api.get('application/features', reqParams, callback);
    }
    /**
    * getLegalDocsUpdates
    * @return {Promise}
    * @soulsdk soul.system.getLegalDocsUpdates
    */

  }, {
    key: "getLegalDocsUpdates",
    value: function getLegalDocsUpdates() {
      return this.api.get('legal-docs/');
    }
    /**
    * acceptLegalDocsUpdate
    * @param {number} [id] - update id
    * @return {Promise}
    * @soulsdk soul.system.acceptLegalDocsUpdate
    */

  }, {
    key: "acceptLegalDocsUpdate",
    value: function acceptLegalDocsUpdate(id) {
      return this.api.post('legal-docs/', {
        id: id
      });
    }
  }]);

  return System;
}(SoulModule);

module.exports = System;